var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsAiCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 53,
    viewBox: "0 0 48 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_4758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5287 6.74584C33.1971 3.41425 28.7658 1.5835 24.0563 1.5835C19.3403 1.5835 14.9154 3.41425 11.5839 6.74584C8.25226 10.0774 6.41504 14.5088 6.41504 19.2183C6.41504 28.7473 15.4265 36.6784 20.2719 40.9351C20.9447 41.5302 21.5204 42.0413 21.9862 42.4682C22.5684 43.0117 23.3123 43.2834 24.0563 43.2834C24.8002 43.2834 25.5442 43.0117 26.1199 42.4682C26.5857 42.0413 27.1679 41.5302 27.8407 40.9351C32.6796 36.6784 41.6911 28.7473 41.6911 19.2183C41.6911 14.5088 39.8603 10.0774 36.5287 6.74584Z",
    fill: "#E13827",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8338 17.7598L21.7285 11.1927C21.3653 11.0252 20.9342 11.1814 20.7649 11.5425L17.8335 17.8184C17.7521 17.9923 17.7435 18.1916 17.8094 18.3718C17.8753 18.5521 18.0097 18.6991 18.1839 18.7804L20.3509 19.7893L19.5997 21.3978C19.5183 21.5716 19.5098 21.7709 19.5757 21.9512C19.6415 22.1314 19.776 22.2784 19.9501 22.3597L21.2728 22.9755L19.5488 26.6671H17.4059V25.0973C17.4059 24.6971 17.0817 24.3734 16.681 24.3734C16.2803 24.3734 15.9561 24.6971 15.9561 25.0973V29.6831C15.9561 30.0832 16.2803 30.4069 16.681 30.4069C17.0817 30.4069 17.4059 30.0832 17.4059 29.6831V28.1146H20.0103C20.292 28.1146 20.5484 27.9513 20.6673 27.6969L22.5868 23.5871L23.9053 24.201C24.0044 24.247 24.1085 24.2689 24.2111 24.2689C24.4844 24.2689 24.7456 24.114 24.8688 23.8511L25.62 22.2426L29.8583 24.2158C29.9573 24.2618 30.0614 24.2837 30.164 24.2837C30.4373 24.2837 30.6985 24.129 30.8217 23.866L30.9341 23.6253L32.7084 24.4513C32.8074 24.4971 32.9115 24.519 33.0141 24.519C33.2874 24.519 33.5486 24.3643 33.6718 24.1013L35.3468 20.5149C35.5159 20.1523 35.3588 19.7219 34.9964 19.553L34.731 19.4294L35.7481 19.1048C36.0321 19.0144 36.2317 18.7592 36.2508 18.4616C36.2699 18.1641 36.1042 17.8855 35.8338 17.7598ZM33.5409 18.2898L32.0989 18.75L21.3384 13.74L21.7723 12.8106L33.5409 18.2898ZM31.5473 22.3138L32.4463 20.3874C32.4893 20.2998 32.5628 20.0635 32.6957 20.0787L33.7263 20.5587L32.6644 22.8333L31.5473 22.3138Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_4758",
    x: 0.915039,
    y: 0.0834961,
    width: 46.2759,
    height: 52.6997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_4758"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_4758",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsAiCamera);
export default __webpack_public_path__ + "static/media/alertsAICamera.7a17deccbb3236ff143c8e947b96f62e.svg";
export { ForwardRef as ReactComponent };